import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import Navbar from "../../../../Navbar/Navbar";
import G_FirstRow from "./G_FirstRow";
import G_SecondRow from "./G_SecondRow";
import G_ThirdRow from "./G_ThirdRow";
import G_ScrollDataTable from "./G_ScrollDataTable";
import G_FourRow from "./G_FourRow";

const G_HeaderIpad = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { P_error } = value;
          return (
            <>
              <Navbar />
              <div className="row mt-5">
                <div className="col-lg-12 text-warning col-12 ">
                  <div
                    className="card card-warning "
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <div
                      className=" col-12 card-header p-1 border-bottom border-warning "
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <G_FirstRow />
                    </div>
                    <div className="card-body">
                      {/* <div className="b--black text-right">
                            {P_error != null && <button className="btn btn-success text-right" type="button"  >
                            {P_error.msg?P_error.msg :P_error.error[0].msg } 
                            <span className='ml-2  border-black' onClick={()=>P_ClearError()}>X</span></button>}
                        </div> */}
                      <form>
                        <G_SecondRow />
                        <G_ThirdRow />
                        <G_ScrollDataTable />
                        <G_FourRow />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default G_HeaderIpad;
